import { defineStore } from 'pinia';
import { ref } from 'vue';
export const useToastStore = defineStore('toast', () => {
    const state = ref({
        visible: false,
        message: '',
        type: 'info',
    });
    function show(message, type = 'info') {
        state.value = { visible: true, message, type };
    }
    function hide() {
        state.value.visible = false;
    }
    return { state, show, hide };
});
